var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgC1Ob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119,
    height: 39,
    viewBox: "0 0 119 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "kcbcszcira",
    d: "M0 0L57.314 0 57.314 28.421 0 28.421z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ppvtt10m5c",
    d: "M0 0L54.95 0 54.95 28.421 0 28.421z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-909 -1879) translate(230 1355) translate(181 447) translate(0 60) translate(498 17) translate(0 9.671)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7k3yibkq6b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#kcbcszcira"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#002337",
    d: "M44.381 0C36.7 0 31.89 4.928 27.783 10.045c-4.232 5.273-7.72 10.741-12.835 11.232l-.056.005c-.091.008-.183.016-.276.021-.137.008-.275.013-.414.013-3.922 0-7.101-3.181-7.101-7.105 0-3.925 3.179-7.106 7.1-7.106 3.923 0 7.102 3.181 7.102 7.106 0 .531-.06 1.05-.171 1.548 1.202-1.309 2.4-2.845 3.658-4.462.76-.976 1.536-1.973 2.344-2.958C24.9 3.42 19.952 0 14.202 0 6.358 0 0 6.362 0 14.21c0 7.849 6.358 14.211 14.202 14.211 9.202 0 14.281-7.07 18.97-13.067.064-.08.127-.162.19-.243l.168-.213.264-.334.101-.128.307-.384.06-.076.333-.41.037-.045.35-.424.021-.025c.12-.145.242-.288.363-.43l.009-.011c2.503-2.93 5.063-5.18 8.258-5.486l.022-.003.036-.003c.091-.008.183-.016.276-.021.137-.007.274-.013.414-.013 3.922 0 7.101 3.181 7.101 7.106 0 .531-.06 1.05-.171 1.548 1.202-1.309 2.4-2.845 3.658-4.462.76-.976 1.537-1.973 2.345-2.958C55.079 3.42 50.13 0 44.38 0",
    mask: "url(#7k3yibkq6b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#002337",
    d: "M74.29 9.671c-15.926 0-19.465 21.316-30.083 21.316-3.91 0-7.079-3.181-7.079-7.105 0-.533.06-1.05.17-1.55-1.197 1.31-2.39 2.846-3.646 4.463-.757.976-1.531 1.973-2.336 2.958 2.226 4.918 7.16 8.34 12.89 8.34.175 0 .349-.005.521-.012 7.357-.218 12.027-5.036 16.027-10.037 4.218-5.271 7.694-10.739 12.793-11.228.018-.003.037-.004.055-.006.092-.008.183-.016.275-.021.137-.008.275-.013.413-.013 3.91 0 7.079 3.181 7.079 7.106 0 .632-.085 1.244-.24 1.828 1.302-1.383 2.586-3.037 3.911-4.744.718-.924 1.45-1.867 2.21-2.803-2.192-5-7.168-8.492-12.96-8.492",
    transform: "translate(-909 -1879) translate(230 1355) translate(181 447) translate(0 60) translate(498 17)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-909 -1879) translate(230 1355) translate(181 447) translate(0 60) translate(498 17) translate(64.01 9.671)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3etmgdt7bd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ppvtt10m5c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00A2E1",
    d: "M40.762 0C27.176 0 22.583 15.441 14.955 20.037c-1.334.804-2.76 1.279-4.343 1.279v-.004c-.066.002-.131.004-.197.004-1.576 0-3.032-.516-4.21-1.387C3.8 20.677 1.67 22.05 0 23.857c2.591 2.806 6.297 4.564 10.415 4.564.066 0 .131-.004.197-.005v.005c7.676 0 12.48-4.93 16.584-10.048 4.227-5.272 7.711-10.739 12.82-11.228l.056-.006c.092-.008.184-.016.276-.021.137-.008.275-.013.414-.013 3.918 0 7.094 3.181 7.094 7.106 0 2.343-1.133 4.42-2.88 5.715l-.004.003c-1.178.871-2.634 1.387-4.21 1.387-1.577 0-3.032-.516-4.21-1.387-2.406.748-4.536 2.121-6.205 3.928 2.591 2.806 6.297 4.564 10.415 4.564 4.117 0 7.823-1.758 10.415-4.564.371-.402.72-.826 1.043-1.268 1.715-2.35 2.73-5.245 2.73-8.378C54.95 6.362 48.598 0 40.762 0",
    mask: "url(#3etmgdt7bd)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#002337",
    d: "M30.134 3.394v11.211c2.048-2.061 4.353-3.866 7.09-5.043V0c-2.56.755-4.948 1.91-7.09 3.394",
    transform: "translate(-909 -1879) translate(230 1355) translate(181 447) translate(0 60) translate(498 17)"
  })))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC1Ob);
export default __webpack_public_path__ + "static/media/c1-ob.c86a7ebf3329bc97c019a44644777711.svg";
export { ForwardRef as ReactComponent };